export const arrayItemWidth = 300;
export const addRemoveButtonWidth = 40;
